/* === buscador.js — overlay de búsqueda === */
(function(){
  var SEARCHES_KEY = 'commons_searches';
  var overlay = null;
  var inputEl = null;
  var goBtn = null;
  var lastTrigger = null;

  /* --- helpers de normalización --- */
  function normalize(str){
    return str.toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g,'');
  }

  /* --- localStorage de recientes --- */
  function getRecientes(){
    try { return JSON.parse(localStorage.getItem(SEARCHES_KEY)) || []; }
    catch(e){ return []; }
  }
  function saveReciente(q){
    q = q.trim(); if(!q) return;
    var arr = getRecientes().filter(function(s){ return s !== q; });
    arr.unshift(q);
    if(arr.length > 6) arr = arr.slice(0,6);
    localStorage.setItem(SEARCHES_KEY, JSON.stringify(arr));
  }

  /* --- búsqueda sobre catálogo --- */
  function buscar(q){
    if(!window.CATALOG) return [];
    var nq = normalize(q);
    return window.CATALOG.products.filter(function(p){
      return normalize(p.title).indexOf(nq) > -1 ||
             normalize(p.brand).indexOf(nq) > -1 ||
             normalize(p.type||'').indexOf(nq) > -1;
    }).slice(0, 9);
  }

  /* --- render de resultado numérico --- */
  function renderCard(p, idx){
    var v0 = p.variants.find(function(v){ return v.available; }) || p.variants[0];
    var num = String(idx+1).padStart(2,'0');
    var imgHtml = p.images[0]
      ? '<img loading="lazy" src="'+p.images[0]+'" alt="">'
      : '<span class="ph-tag">FOTO PENDIENTE</span>';
    return '<a class="busq-card" href="/products/'+p.handle+'" data-track="buscador-resultado">' +
      '<div class="busq-card-ph" data-bg="blanco">' +
        '<span class="busq-card-num">'+num+'</span>' +
        '<span class="busq-card-brand">'+p.brand.toUpperCase()+'</span>' +
        imgHtml +
      '</div>' +
      '<div class="busq-card-info">' +
        '<p>'+p.title.toUpperCase()+'</p>' +
        '<p class="busq-card-precio">'+(v0?('$'+Math.round(v0.price).toLocaleString('en-US')):'—')+'</p>' +
      '</div>' +
    '</a>';
  }

  /* --- render cuerpo del overlay --- */
  function renderBody(q){
    var body = overlay.querySelector('.busq-body');
    var resultados = q.trim() ? buscar(q) : [];
    var recientes = getRecientes();

    var popularTitles = (window.CATALOG ? window.CATALOG.products.slice(0,5) : [])
      .map(function(p){ return p.title; });

    var leftHtml = '';
    if(recientes.length){
      leftHtml += '<p class="busq-section-title">RECIENTES</p>' +
        '<ul class="busq-items">' +
        recientes.slice(0,3).map(function(s){
          return '<li onclick="_busqSetAndSearch(\''+s.replace(/'/g,'\\\'')+'\')">'+s+'</li>';
        }).join('') + '</ul>';
    }
    leftHtml += '<p class="busq-section-title">POPULAR AHORA</p>' +
      '<ul class="busq-items">' +
      popularTitles.map(function(t){
        return '<li onclick="_busqSetAndSearch(\''+t.replace(/'/g,'\\\'')+'\')">' + t + '</li>';
      }).join('') + '</ul>';

    /* sin sección MARCAS (fuera — cambio Kike 13/07) */

    var rightHtml = '';
    if(q.trim()){
      if(resultados.length){
        rightHtml += '<div class="busq-resultados-head">' +
          '<span>RESULTADOS</span>' +
          '<span>"'+q+'" — '+resultados.length+'</span>' +
          '</div>' +
          '<div class="busq-grid">' + resultados.map(renderCard).join('') + '</div>';
      } else {
        rightHtml += '<p class="busq-empty">Sin resultados para "'+q+'" — ' +
          '<a href="'+UI.WA+'" target="_blank" rel="noopener">escríbenos por WhatsApp →</a></p>';
      }
    }

    /* Desktop: two column grid (secciones izq / resultados der); móvil: los RESULTADOS
       van PRIMERO (CSS order — cambio Kike 13/07: los productos son lo primero que ves).
       Sin link "Ver todos los resultados": iba a la colección ALL, deshabilitada
       como destino navegable (cambio Kike 12/07). */
    body.innerHTML =
      '<div class="busq-left-col">' + leftHtml + '</div>' +
      '<div class="busq-right-col">' + rightHtml + '</div>';
  }

  /* --- abrir overlay --- */
  function openBuscador(){
    lastTrigger = document.activeElement;
    if(!overlay) buildOverlay();
    renderBody('');
    overlay.classList.add('open');
    if(inputEl) { inputEl.value = ''; inputEl.focus(); }
    if(goBtn) goBtn.classList.remove('visible');
  }

  /* --- cerrar overlay --- */
  function closeBuscador(){
    if(overlay) overlay.classList.remove('open');
    if(lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  /* --- lanzar búsqueda (guardar en recientes + render) --- */
  function doSearch(q){
    if(q && q.trim()) saveReciente(q.trim());
    renderBody(q);
    var body = overlay && overlay.querySelector('.busq-body');
    if(body) body.scrollTop = 0;
  }

  /* submit explícito (botón BUSCAR / tecla buscar del teclado móvil):
     navega a la página de resultados con solo los productos filtrados (Kike 13/07) */
  function submitSearch(){
    if(!inputEl) return;
    var q = inputEl.value.trim();
    if(!q){ inputEl.focus(); return; }
    saveReciente(q);
    var base = (window.THEME && window.THEME.routes && window.THEME.routes.search) || '/search';
    /* en el preview (dominio myshopify) hay que conservar _fd/_ab: sin ellos el
       redirect al dominio primario descarta el preview y sirve el theme viejo.
       En el dominio real no aplica (el hostname no es myshopify). */
    var extra = /\.myshopify\.com$/.test(location.hostname) ? '&_fd=0&_ab=0' : '';
    window.location.href = base + '?q=' + encodeURIComponent(q) + extra;
  }

  /* helper global para onclick desde HTML generado */
  window._busqSetAndSearch = function(val){
    if(!inputEl) return;
    inputEl.value = val;
    if(goBtn) goBtn.classList.toggle('visible', val.length > 0);
    doSearch(val);
  };
  window._busqDoSearch = doSearch;

  /* --- construir overlay DOM --- */
  function buildOverlay(){
    var svgSearch = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><circle cx="7.5" cy="7.5" r="6" stroke="#0C0C0C" stroke-width="1.8"/><line x1="12.2" y1="12.2" x2="17" y2="17" stroke="#0C0C0C" stroke-width="1.8" stroke-linecap="round"/></svg>';

    overlay = document.createElement('div');
    overlay.className = 'busq-overlay';
    overlay.setAttribute('role','dialog');
    overlay.setAttribute('aria-modal','true');
    overlay.setAttribute('aria-label','Buscar en Commons');
    overlay.innerHTML =
      '<div class="busq-topbar">' +
        '<a class="busq-logo" href="'+((window.THEME&&window.THEME.routes&&window.THEME.routes.home)||"/")+'"><img src="'+((window.THEME&&window.THEME.assets&&window.THEME.assets.logo)||"")+'" alt="COMMONS®"></a>' +
        '<button class="busq-close" aria-label="Cerrar búsqueda">CERRAR ✕</button>' +
      '</div>' +
      '<div class="busq-row">' +
        svgSearch +
        '<input id="busqInput" type="search" placeholder="Buscar" autocomplete="off" autocorrect="off" spellcheck="false">' +
        '<button class="busq-go" aria-label="Buscar">BUSCAR</button>' +
      '</div>' +
      '<div class="busq-body"></div>';

    document.body.appendChild(overlay);

    inputEl = overlay.querySelector('#busqInput');
    goBtn = overlay.querySelector('.busq-go');

    goBtn.addEventListener('click', submitSearch);

    overlay.querySelector('.busq-close').addEventListener('click', closeBuscador);

    inputEl.addEventListener('input', function(){
      var q = inputEl.value;
      goBtn.classList.toggle('visible', q.length > 0);
      renderBody(q);
    });

    inputEl.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){ submitSearch(); }
    });

  }

  /* --- expose via UI --- */
  document.addEventListener('DOMContentLoaded', function(){
    if(typeof UI !== 'undefined'){
      UI.openSearch = openBuscador;
    }
    window._openBuscador = openBuscador;
  });

  /* Escape closes buscador too */
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay && overlay.classList.contains('open')){
      closeBuscador();
    }
  });
})();
